import Vue from 'vue'
import store from 'store'
import qs from 'qs'

export default {
    createTemplate(rootState, newTemplate, callbacks)   {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La création de la grille d'audit «" + newTemplate.title + '» a échoué.',
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "title": newTemplate.title == "" ? "Grille sans thème" : newTemplate.title,
            "nbPatients": newTemplate.nbPatients,
            "satisfactionSurvey": newTemplate.satisfactionSurvey,
            "explanationStep1": newTemplate.explanations['FIRST_STEP'],
            "explanationStepCritic": newTemplate.explanations['CRITIC_STEP'],
            "explanationStep2":newTemplate.explanations['SECOND_STEP'],
            "explanationSatisfactionSurvey": newTemplate.explanations['SATISFACTION_SURVEY'],
            "defaultTemplate": newTemplate.defaultTemplate,
            "targetId": newTemplate.targetId,
            "isReady": newTemplate.isReady
        })});
        
        Vue.axios.post(rootState.baseUrl + "/admin/template/create", params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    updateTemplate(rootState, newTemplate, callbacks)   {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La mise à jour de la grille d'audit «" + newTemplate.title + '» a échoué.',
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "title": newTemplate.title == "" ? "Grille sans thème" : newTemplate.title,
            "nbPatients": newTemplate.nbPatients,
            "satisfactionSurvey": newTemplate.satisfactionSurvey,
            "explanationStep1": newTemplate.explanations['FIRST_STEP'],
            "explanationStepCritic": newTemplate.explanations['CRITIC_STEP'],
            "explanationStep2":newTemplate.explanations['SECOND_STEP'],
            "explanationSatisfactionSurvey": newTemplate.explanations['SATISFACTION_SURVEY'],
            "defaultTemplate": newTemplate.defaultTemplate,
            "targetId": newTemplate.targetId,
            "isReady": newTemplate.isReady
        })});

        Vue.axios.post(rootState.baseUrl + "/admin/template/update/" + newTemplate.id, params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    getTemplateList(rootState, page, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La récupération de la liste de grilles d'audit a échoué.",
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/admin/templates/" + page, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    getTemplate(rootState, templateId, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La récupération de la grille d'audit a échoué.",
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/admin/template/" + templateId, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    getDefaultTemplate(rootState, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La récupération de la grille d'audit par défaut échoué.",
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/admin/template/default", {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    duplicateTemplate(rootState, templateId, targetId, callbacks)   {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La duplication de la grille d'audit «" + newTemplate.title + '» a échoué.',
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
                                    "targetId": targetId
                                    })});

        Vue.axios.post(rootState.baseUrl + "/admin/template/" + templateId + "/duplicate", params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    setTargetTemplate(rootState, templateId, targetId, callbacks)    {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "Le lien entre le thème et la grille d'audit a échoué.",
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "targetId": targetId
        })});

        Vue.axios.post(rootState.baseUrl + "/admin/template/" + templateId + "/set-target", params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    getTargetTemplates(rootState, onlyEnabled, callbacks)    {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La récupération des thèmes a échoué.",
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/admin/target-templates/" + (onlyEnabled ? "1" : "") + "?other=", {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    }
};